<template>
  <div>
    <div class="page-title">分配管理</div>
    <div class="page-content">
      <page-table
        :showPage="false"
        :col="columns"
        :data="tableData"
      ></page-table>
      <!-- <v-table
        is-horizontal-resize
        style="width: 100%"
        :columns="columns"
        :table-data="tableData"
        is-vertical-resize
        :vertical-resize-offset='40'
        :title-bg-color="'#EFF3F5'"
        :even-bg-color="'#F3F6F8'"
        :show-horizontal-border="false"
        :show-vertical-border="false"
        :title-row-height="50"
        :row-height="32"
      ></v-table> -->
    </div>
</div>
</template>

<script>
// import 'vue-easytable/libs/themes-base/index.css'
// import { VTable } from 'vue-easytable'
import pageTable from '@/components/pageCom/pageTable'
export default {
  components: { pageTable },
  data() {
    return {
      tableData: [
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' },
        { classType: '按机构分类别', level1: '医疗卫生机构', level2: '医院', level3: '综合医院' }
      ],
      columns: [
        { field: 'classType', title: '一级分类', titleAlign: 'left', columnAlign: 'left', isResize: true, width: 100 },
        { field: 'level1', title: '一级分类', titleAlign: 'left', columnAlign: 'left', isResize: true, width: 100 },
        { field: 'level2', title: '二级分类', titleAlign: 'left', columnAlign: 'left', isResize: true, width: 100 },
        { field: 'level3', title: '三级分类', titleAlign: 'left', columnAlign: 'left', isResize: true, width: 100 }
      ]
    }
  }
}
</script>
